import React from 'react';

function SasktelLogoRightSVG(props) {
  return (
    <svg fill={props.fill} width={props.width} height={props.height} viewBox={props.viewbox} className={props.classes} xmlns="http://www.w3.org/2000/svg">
      <title></title>
      <path
        stroke="null"
        d="m105.307195,2.762543l0,83.88541l353.857795,0l0,-40.158664l563.368919,0l0,-43.726746l-917.226713,0zm896.57774,117.917822l-917.301831,0l0,83.88541l393.816145,0l0,-40.083546l523.485686,0l0,-43.801864zm-20.690705,117.905302l-917.310177,0l0,83.922968l434.100004,0l0,-40.121105l483.214346,0l-0.004173,-43.801864zm-20.536297,117.871916l-917.347736,0l0,84.006432l472.835608,0l0,-40.204569l444.516301,0l-0.004173,-43.801864zm-20.699051,117.992939l-917.389468,0l0,83.922968l513.127814,0l0,-40.158664l404.261654,0l0,-43.764305zm-938.000882,117.95538l0,83.88541l554.429933,0l0,-40.121105l362.921976,0l0,-43.764305l-917.351909,0z"
      />
    </svg>
  );
}

export default SasktelLogoRightSVG;
